import React from 'react';
import PropTypes from 'prop-types';
import css from './CwShellTopNavLogo.scss';
import CwImage from '../../cwimage/CwImage';

const CwShellTopNavLogo = (props) => {
  return (
    <div
      className={css.cwShellTopNavLogo}
      style={props.style}
      onClick={props.onClick}
    >
      {props.icon.length > 0 &&
      <CwImage
        className={css.cwShellTopNavLogoImage}
        src={props.icon}
      />
      }
      {props.children}
    </div>
  );
};

CwShellTopNavLogo.propTypes = {
  children: PropTypes.any,
  /**
   * Path to icon
   */
  icon: PropTypes.string,
  /**
   * Callback function that is fired when logo is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Allows custom styling
   */
  style: PropTypes.object
};

CwShellTopNavLogo.defaultProps = {
  icon: ''
};

export default CwShellTopNavLogo;


// WEBPACK FOOTER //
// ./src/components/cwshelltopnav/cwshelltopnavlogo/CwShellTopNavLogo.jsx